<template>
  <div style="height: 100%;">
      <div><el-button type="danger" @click="back" style="float: right;margin-bottom: 10px;">返回</el-button></div>

    	<div style="width: 100%;height: 100%;overflow:auto;">
        <iframe
            :src="iframeSrc"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="auto">
        </iframe>
      </div>
  </div>

</template>

<script>
import GrouponApi from "../../../../api/sm/market/groupon/grouponApi";
import JsBarCode from "jsbarcode";

export default {
  name: "groupPrintItem",
  props: {
    page: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dataList: [],
      dataList1: [],
      isPrint: false,
      iframeSrc: ''
    }
  },
  mounted() {
    this.iframeSrc = `/smp-client/printItem?id=` + this.item.id
    console.log(this.iframeSrc)
  },
  methods: {
    back() {
      this.$emit("back", {formStatus: 'list'})
    }
  }
}
</script>

<style scoped>
html, body{
  height: 100%;
}
</style>